/**
 * @file ChangeCouncil
 */

'use strict';

/**
 * @classname ChangeCouncil
 * @classdesc ChangeCouncil
 */
export default class ChangeCouncil {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log(`ChangeCouncil.constructor`);
		this._$e = $e;
		this._controller = controller;
		this._getDistricts = this._$e.data('get-districts') || null;
		this._getAffiliations = this._$e.data('get-affiliations') || null;
		this._getDormantOrganization = this._$e.data('get-dormant-organization') || null;
		this._$e.on('change', () => this.onChange());
		this._controller.on('getDistrictsComplete', () => this.onGetDistrictsComplete());
		this._controller.on('getDistrictsAffiliationsComplete', () => this.onGetDistrictsAffiliationsComplete());
		this._controller.on('getGroupsFromCouncilComplete', () => this.onGetGroupsFromCouncilComplete());
		this._controller.on('getGroupsAffiliationsFromCouncilComplete', () => this.onGetGroupsAffiliationsFromCouncilComplete());
		this._controller.on('getDistrictsGroupsComplete', () => this.onGetDistrictsGroupsComplete());
		this._controller.on('getDistrictsGroupsAffiliationsComplete', () => this.onGetDistrictsGroupsAffiliationsComplete());
		this._controller.on('dispatchChangeCouncilOnChange', () => this.onChange());
		this._controller.on('blankGroupNoDistrict', () => this.onChange());
		this._inTable = this._$e.closest('.table').hasClass('registration')? true: false;
		this._inModal = !!this._$e.closest('.modal').length;
		this._atSearch = this._$e.hasClass('search-item')? true : false;
		this._changed = false;
	}


	/**
	 * 'change' のコールバック
	 *
	 * @memberof ChangeCouncil
	 * @return {undefined}
	 */
	onChange() {
		console.log(`ChangeCouncil.onChange`);
		// getDistrictsがない場合は無視
		console.log(this._getDistricts)
		if(!this._getDistricts) return;
		if(this._$e.hasClass('ignore')) return;
		// 値がない場合は、地区以下をクリア
		if(this._$e.val() === '' || this._$e.val() === 'all'){
			const $tr = this._$e.closest('.tr');
			$tr.find('.district_id').html('<option value="">--</option>');
			$tr.find('.group_id').html('<option value="">--</option>');
			$tr.find('.affiliation_id').html('<option value="">--</option>');
			$tr.find('.title_id').html('<option value="">--</option>');
			$('[data-search-item=district_id]').html('<option value="">--</option>');
			$('[data-search-item=group_id]').html('<option value="">--</option>');
			return;
		}
		// 通常の地区取得
		if(this._$e.find('option:selected').attr('data-has-no-district') === 'true'){
			console.log('地区なしの場合');
			console.log(this._$e.find('option:selected').attr('data-has-no-district'));
			this._getAffiliations ? this._controller.getGroupsAffiliationsFromCouncil(this._$e.val(), this._getDormantOrganization) : this._controller.getGroupsFromCouncil(this._$e.val(), this._getDormantOrganization);
		}else if(this._$e.find('option:selected').attr('data-has-group') === 'true'){
			console.log('地区と直轄団がある場合');
			console.log(this._$e.find('option:selected').attr('data-has-group'));
			this._getAffiliations ? this._controller.getDistrictsGroupsAffiliations(this._$e.val(), this._getDormantOrganization) : this._controller.getDistrictsGroups(this._$e.val(), this._getDormantOrganization);
		}else{
			console.log('地区しかない場合');
			this._getAffiliations ? this._controller.getDistrictsAffiliations(this._$e.val(), this._getDormantOrganization) : this._controller.getDistricts(this._$e.val(), this._getDormantOrganization);
		}
		this._changed = true;
	}


	/**
	 * 地区リスト取得完了コールバック
	 *
	 * @memberof ChangeCouncil
	 * @return {undefined}
	 */
	onGetDistrictsComplete() {
		if(!this._changed) return;
		console.log(`ChangeCouncil.onGetDistrictsComplete`);
		console.log(this._controller._districts);
		if(this._inTable) {
			this._$e.closest('.tr').find('.district_id').html(this.createOptions(this._controller._districts));
			this._$e.closest('.tr').find('.group_id').html('<option value="">--</option>');
			this._$e.closest('.tr').find('.affiliation_id').html('<option value="">--</option>');
			this._$e.closest('.tr').find('.title_id').html('<option value="">--</option>');
		} else if (this._inModal) {
			this._$e.closest('.modal').find('.district_id').html(this.createOptions(this._controller._districts));
			this._$e.closest('.modal').find('.group_id').html('<option value="">--</option>');
			this._$e.closest('.modal').find('.affiliation_id').html('<option value="">--</option>');
			this._$e.closest('.modal').find('.title_id').html('<option value="">--</option>');
		} else if (this._atSearch) {
			console.log('検索画面');
			$('.search-item[data-search-item=district_id]').html(this.createOptions(this._controller._districts));
			$('.search-item[data-search-item=group_id]').html('<option value="">--</option>');
		} else {
			$('.district_id').html(this.createOptions(this._controller._districts));
			$('.group_id').html('<option value="">--</option>');
			$('.affiliation_id').html('<option value="">--</option>');
			$('.title_id').html('<option value="">--</option>');
		}
		this._changed = false;
	}


	/**
	 * 地区リスト・所属リスト取得完了コールバック
	 *
	 * @memberof ChangeCouncil
	 * @return {undefined}
	 */
	onGetDistrictsAffiliationsComplete() {
		if(!this._changed) return;
		console.log(`ChangeCouncil.onGetDistrictsAffiliationsComplete`);
		console.log(this._controller._districts);
		console.log(this._controller._affiliations);
		if(this._inTable){
			this._$e.closest('.tr').find('.district_id').html(this.createOptions(this._controller._districts));
			this._$e.closest('.tr').find('.group_id').html('<option value="">--</option>');
			this._$e.closest('.tr').find('.affiliation_id').html(this.createOptions(this._controller._affiliations));
			this._$e.closest('.tr').find('.title_id').html('<option value="">--</option>');
		} else if (this._inModal) {
			this._$e.closest('.modal').find('.district_id').html(this.createOptions(this._controller._districts));
			this._$e.closest('.modal').find('.group_id').html('<option value="">--</option>');
			this._$e.closest('.modal').find('.affiliation_id').html(this.createOptions(this._controller._affiliations));
			this._$e.closest('.modal').find('.title_id').html('<option value="">--</option>');
		}else{
			$('.district_id').html(this.createOptions(this._controller._districts));
			$('.group_id').html('<option value="">--</option>');
			$('.affiliation_id').html(this.createOptions(this._controller._affiliations));
			$('.title_id').html('<option value="">--</option>');
		}
		this._changed = false;
	}


	/**
	 * 地区リスト取得完了コールバック
	 *
	 * @memberof ChangeCouncil
	 * @return {undefined}
	 */
	onGetDistrictsGroupsComplete() {
		if(!this._changed) return;
		console.log(`ChangeCouncil.onGetDistrictsGroupsComplete`);
		console.log(this._controller._districts);
		console.log(this._controller._groups);
		if(this._inTable) {
			this._$e.closest('.tr').find('.district_id').html(this.createOptions(this._controller._districts));
			this._$e.closest('.tr').find('.group_id').html(this.createOptions(this._controller._groups));
			this._$e.closest('.tr').find('.affiliation_id').html('<option value="">--</option>');
			this._$e.closest('.tr').find('.title_id').html('<option value="">--</option>');
		} else if (this._inModal) {
			this._$e.closest('.modal').find('.district_id').html(this.createOptions(this._controller._districts));
			this._$e.closest('.modal').find('.group_id').html(this.createOptions(this._controller._groups));
			this._$e.closest('.modal').find('.affiliation_id').html('<option value="">--</option>');
			this._$e.closest('.modal').find('.title_id').html('<option value="">--</option>');
		} else {
			$('.district_id').html(this.createOptions(this._controller._districts));
			$('.group_id').html(this.createOptions(this._controller._groups));
			$('.affiliation_id').html('<option value="">--</option>');
			$('.title_id').html('<option value="">--</option>');
		}
		this._changed = false;
	}


	/**
	 * 地区リスト・所属リスト取得完了コールバック
	 *
	 * @memberof ChangeCouncil
	 * @return {undefined}
	 */
	onGetDistrictsGroupsAffiliationsComplete() {
		if(!this._changed) return;
		console.log(`ChangeCouncil.onGetDistrictsGroupsAffiliationsComplete`);
		console.log(this._controller._districts);
		console.log(this._controller._groups);
		console.log(this._controller._affiliations);
		if(this._inTable){
			this._$e.closest('.tr').find('.district_id').html(this.createOptions(this._controller._districts));
			this._$e.closest('.tr').find('.group_id').html(this.createOptions(this._controller._groups));
			this._$e.closest('.tr').find('.affiliation_id').html(this.createOptions(this._controller._affiliations));
			this._$e.closest('.tr').find('.title_id').html('<option value="">--</option>');
		} else if (this._inModal) {
			this._$e.closest('.modal').find('.district_id').html(this.createOptions(this._controller._districts));
			this._$e.closest('.modal').find('.group_id').html(this.createOptions(this._controller._groups));
			this._$e.closest('.modal').find('.affiliation_id').html(this.createOptions(this._controller._affiliations));
			this._$e.closest('.modal').find('.title_id').html('<option value="">--</option>');
		}else{
			$('.district_id').html(this.createOptions(this._controller._districts));
			$('.group_id').html(this.createOptions(this._controller._groups));
			$('.affiliation_id').html(this.createOptions(this._controller._affiliations));
			$('.title_id').html('<option value="">--</option>');
		}
		this._changed = false;
	}


	/**
	 * 団リスト取得完了コールバック
	 *
	 * @memberof ChangeCouncil
	 * @return {undefined}
	 */
	onGetGroupsFromCouncilComplete() {
		if(!this._changed) return;
		console.log(`ChangeCouncil.onGetGroupsFromCouncilComplete`);
		console.log(this._controller._groups);
		if(this._inTable) {
			this._$e.closest('.tr').find('.district_id').html('<option value="">--</option>');
			this._$e.closest('.tr').find('.group_id').html(this.createOptions(this._controller._groups));
			this._$e.closest('.tr').find('.affiliation_id').html('<option value="">--</option>');
			this._$e.closest('.tr').find('.title_id').html('<option value="">--</option>');
		} else if (this._inModal) {
			this._$e.closest('.modal').find('.district_id').html('<option value="">--</option>');
			this._$e.closest('.modal').find('.group_id').html(this.createOptions(this._controller._groups));
			this._$e.closest('.modal').find('.affiliation_id').html('<option value="">--</option>');
			this._$e.closest('.modal').find('.title_id').html('<option value="">--</option>');
		} else {
			$('.district_id').html('<option value="">--</option>');
			$('.group_id').html(this.createOptions(this._controller._groups));
			$('.affiliation_id').html('<option value="">--</option>');
			$('.title_id').html('<option value="">--</option>');
		}
		this._changed = false;
	}


	/**
	 * 団リスト・所属リスト取得完了コールバック
	 *
	 * @memberof ChangeCouncil
	 * @return {undefined}
	 */
	onGetGroupsAffiliationsFromCouncilComplete() {
		if(!this._changed) return;
		console.log(`ChangeCouncil.onGetGroupsAffiliationsFromCouncilComplete`);
		console.log(this._controller._groups);
		console.log(this._controller._affiliations);
		if(this._inTable){
			this._$e.closest('.tr').find('.district_id').html('<option value="">--</option>');
			this._$e.closest('.tr').find('.group_id').html(this.createOptions(this._controller._groups));
			this._$e.closest('.tr').find('.affiliation_id').html(this.createOptions(this._controller._affiliations));
			this._$e.closest('.tr').find('.title_id').html('<option value="">--</option>');
		} else if (this._inModal) {
			this._$e.closest('.modal').find('.district_id').html('<option value="">--</option>');
			this._$e.closest('.modal').find('.group_id').html(this.createOptions(this._controller._groups));
			this._$e.closest('.modal').find('.affiliation_id').html(this.createOptions(this._controller._affiliations));
			this._$e.closest('.modal').find('.title_id').html('<option value="">--</option>');
		} else {
			$('.district_id').html('<option value="">--</option>');
			$('.group_id').html(this.createOptions(this._controller._groups));
			$('.affiliation_id').html(this.createOptions(this._controller._affiliations));
			$('.title_id').html('<option value="">--</option>');
		}
		this._changed = false;
	}


	/**
	 * option生成
	 *
	 * @memberof ChangeCouncil
	 * @return {undefined}
	 */
	createOptions(items) {
		console.log(`ChangeCouncil.createOptions`);
		let options = '<option value="">▼選択</option>';
		items.forEach(item => options += `<option value='${item.id}'>${item.name}</option>`);
		return options
	}
}
